<ng-container *ngIf="view === 'list'">
  <div class="accept-conditions">
    <div class="back-link" (click)="close()">
      <img src="../../../../../../assets/icons/back-icon.svg" alt="" />
      <span>Volver a operaciones</span>
    </div>

    <p class="page-title">Condiciones por aceptar</p>
    <p class="page-subtitle">
      Tus operaciones vienen agrupadas por condición. Dentro de cada grupo, todas tienen la misma tasa y la
      misma garantía.
    </p>

    <div class="bulk-card" *ngFor="let bulk of bulks; let bulkIndex = index">
      <div class="bulk-header">
        <div class="bulk-conditions">
          <p class="bulk-index">Condición {{ bulkIndex + 1 }} de {{ bulks.length }}</p>

          <div class="condition-values">
            <div class="condition">
              <p class="condition-label">Tasa mensual</p>
              <p class="condition-value">{{ bulk.tdmPercentage }} %</p>
            </div>
            <div class="condition">
              <p class="condition-label">Garantía retenida</p>
              <p class="condition-value">{{ bulk.reservationPercentage }} %</p>
            </div>
          </div>
        </div>

        <div class="bulk-totals">
          <p class="bulk-count">{{ selectedCount(bulk) }} de {{ bulk.operations.length }} operaciones</p>
          <p class="bulk-amount" *ngIf="!bulk.isConfirming">
            Recibes {{ bulk.currency | currencySymbol }} {{ totalToReceive(bulk) | numberSpacing }}
          </p>
        </div>
      </div>

      <div class="bulk-actions">
        <lib-ui-button
          variant="filled"
          size="l"
          [fullWidth]="false"
          [isDisabled]="selectedCount(bulk) === 0"
          [label]="acceptButtonLabel(bulk)"
          (click)="acceptBulk(bulk)"
        ></lib-ui-button>

        <span class="detail-toggle" (click)="toggleDetail(bulk)">
          {{ bulk.expanded ? 'Ocultar el detalle' : 'Ver qué operaciones incluye' }}
          <img
            [class.expanded]="bulk.expanded"
            src="../../../../../../assets/icons/chevron_right_black_24dp.svg"
            alt=""
          />
        </span>
      </div>

      <div class="bulk-detail" *ngIf="bulk.expanded">
        <div class="operation-row" *ngFor="let operation of bulk.operations">
          <div class="operation-check">
            <app-checkbox
              content=""
              [checked]="operation.selected"
              (selectionChanged)="toggleOperation(bulk, operation)"
            ></app-checkbox>
          </div>

          <div class="operation-company">
            <p class="company">{{ companyName(operation) | uppercase }}</p>
            <p class="meta">
              {{ getCodes(operation) }} · vence {{ operation.paymentDate | formatDate }} ·
              {{ getDuration(operation) }} días
            </p>
          </div>

          <div class="operation-figure">
            <p class="figure-label">Facturas</p>
            <p class="figure-value">
              {{ operation.currency | currencySymbol }} {{ operation.netAmount | numberSpacing }}
            </p>
          </div>

          <div class="operation-figure">
            <p class="figure-label">Costo</p>
            <p class="figure-value">
              {{ operation.currency | currencySymbol }} {{ operation.factoringCost | numberSpacing }}
            </p>
          </div>

          <div class="operation-figure">
            <p class="figure-label">Garantía</p>
            <p class="figure-value">
              {{ operation.currency | currencySymbol }} {{ operation.reservationAmount | numberSpacing }}
            </p>
          </div>

          <div class="operation-figure" *ngIf="!bulk.isConfirming">
            <p class="figure-label">Recibes ahora</p>
            <p class="figure-value strong">
              {{ operation.currency | currencySymbol }} {{ amountToReceive(operation) | numberSpacing }}
            </p>
          </div>
        </div>

        <p class="bulk-footnote">La garantía retenida se devuelve cuando cada empresa paga su factura.</p>
      </div>
    </div>

    <div class="page-disclaimer">
      <img src="../../../../../../assets/icons/info-new.svg" alt="" />
      <span>
        Al aceptar un grupo autorizas a Finsmart a financiar esas facturas en esas condiciones. Lo que no
        aceptes queda pendiente y no vence.
      </span>
    </div>
  </div>
</ng-container>

<div class="result-view" *ngIf="view === 'result'">
  <app-save-result
    [success]="{ savingSucceeded: acceptSucceeded }"
    mode="edit"
    [resultConfig]="resultConfig"
    (onDone)="onResultDone()"
  >
  </app-save-result>
</div>
